import styled from "@emotion/styled";
import theme from "../../../../theme";
import { Box, Divider, Typography } from "@mui/material";
import { SERVICE_STATUS } from "@home-health-notify/domain";
import { shouldForwardProp } from "../../../../common/Common.style";
import { patientServiceColor } from "hhn-commons";

type AdvancedSearchProp = {
  status: SERVICE_STATUS;
};

export const ServiceStatus = styled(Typography, {
  shouldForwardProp: prop =>
    shouldForwardProp<AdvancedSearchProp>(["status"], prop),
})<AdvancedSearchProp>(({ status }) => ({
  color: patientServiceColor(status),
  fontSize: "13px",
  marginRight: "5px",
}));

export const UserWorkloadWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 7px;
  gap: 5px;
`;

export const PatientStatusWrapper = styled(Box)`
  display: flex;
`;

export const PatientStatusItemWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

export const PatientStatusCount = styled(Typography)`
  font-size: 14px;
  margin-right: 8px;
`;

export const VerticalDivider = styled(Divider)`
  height: 24px;
  margin-right: 8px;
`;

export const ServiceStatusWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

export const ServiceStatusItemWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

export const ServiceStatusCount = styled(Typography)`
  font-size: 13px;
  margin-right: 8px;
`;

export const SOCTotalCount = styled(Typography)`
  font-size: 13px;
  margin-right: 8px;
`;

export const AdvanceSearchContainer = styled(Box)`
  display: flex;
  height: 100%;
`;

// The list pane in the AdvanceSearch / CareMap dialog. Keeps today's 30% at
// wide widths but never drops below 400 px so filter chips don't ellipsize
// and clinician cards stay readable at the 960 px floor
export const ClinicianListContainer = styled(Box)`
  width: 30%;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ClinicianList = styled(Box)`
  overflow-y: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const PatientHeaderContainer = styled(Box)`
  padding: 10px;
`;

export const ClinicianDisciplineChipsWrapper = styled(Box)`
  padding-top: 8px;
`;

export const DistanceChipsWrapper = styled(Box)`
  padding-bottom: 8px;
`;

export const WorkloadLoaderContainer = styled(Box)`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 10px;
`;

export const LoadingWorkloadText = styled(Typography)`
  font-size: 14px;
  color: ${theme.palette.grey[700]};
`;

export const CountsContainer = styled(Box)`
  display: flex;
  gap: 16px;
  padding: 8px 16px;
`;

export const FilterChipContainer = styled(Box)`
  padding: 0 16px 8px;
`;

export const CountLabel = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: ${theme.palette.text.secondary};
`;
